import { Button } from "@/components/ui/button"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Printer } from 'lucide-react'

const StudentPaymentHistory = ({ paymentHistory, formatDate, formatCurrency, onPrintReceipt }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl font-semibold text-gray-800">Payment History</CardTitle>
        <CardDescription>
          View all your previous fee payments
        </CardDescription>
      </CardHeader>
      <CardContent>
        {paymentHistory.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Receipt No.</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Description</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Payment Method</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {paymentHistory.map((payment) => (
                <TableRow key={payment._id}>
                  <TableCell className="font-medium">REC-{payment._id.substring(0, 8)}</TableCell>
                  <TableCell>{formatDate(payment.paidDate)}</TableCell>
                  <TableCell>
                    {payment.quarter ? `${payment.quarter.toUpperCase()} Fee` : "Fee Payment"}
                  </TableCell>
                  <TableCell>
                    {formatCurrency(payment.totalPayable ?? payment.totalAmount)}
                  </TableCell>
                  <TableCell>{payment.paymentMethod}</TableCell>
                  <TableCell>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onPrintReceipt(payment)}
                      className="flex items-center gap-2"
                    >
                      <Printer className="h-4 w-4" />
                      Receipt
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg">
            <h3 className="text-lg font-medium text-gray-900">No payment history</h3>
            <p className="mt-2 text-sm text-gray-500">
              You haven't made any fee payments yet.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default StudentPaymentHistory
